import React, { useState, useEffect, useContext, useCallback, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import 'react-toastify/dist/ReactToastify.css';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import DivLayout from "../../../../../components/sales/divLayout/divLayout";
import { Button } from "react-bootstrap";
import Images from 'assets/images/imageData';

const ViewQuotation = ({
    match,
    quotation,
    getQuotation,
}) => {
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getQuotation(match.params.id)
            setIsLoading(false)
        })()
    }, [])

    const headerBtns = () => {
        return (
            <Fragment>
                {quotation?.user && 
                <Link
                    to={`${baseUrl}/project-onboarding/edit-quotation/${match.params.id}`}
                    className="btn btn-primary d-md-inline-block"
                >
                    {[3, 5, 7].includes(quotation?.quotation?.[0]?.status_id) ? 'Update' : 'Edit'}
                    <img src={Images?.ArrowRight} alt="" />
                </Link>}
            </Fragment>
        );
    }

    return (
        <Layout
            title="Quotation Listing"
            Buttons={[1, 3, 5, 7].includes(quotation?.quotation?.[0]?.status_id) && headerBtns}
            isGoback
            isLoading={isLoading}
        >
            <div className="panel-card card-details" width="100%">
                <div className="panel-heading">{localization.quotation}</div>
                <div className="panel-body">
                    <div className="details-listing detail_alignment">
                        <DivLayout heading={"Client Name"} data={quotation?.quotation?.[0]?.client_name} />
                        <DivLayout heading={"Solution"} data={quotation?.quotation?.[0]?.solution_type} />
                        <DivLayout heading={"AMC Cost"} data={quotation?.quotation?.[0]?.amc_cost} />
                        <DivLayout heading={"Server Charge"} data={quotation?.quotation?.[0]?.server_charge} />
                        <DivLayout heading={"Status"} data={quotation?.quotation?.[0]?.status} />
                        <DivLayout heading={"Created By"} data={quotation?.quotation?.[0]?.created_by} />
                        <DivLayout heading={"Created At"} data={quotation?.quotation?.[0]?.created_at} />
                        <DivLayout heading={"Updated At"} data={quotation?.quotation?.[0]?.updated_at} />
                        {quotation?.quotation_material?.map((element, index) => {
                            return (<><hr />
                                <DivLayout heading={index + 1 + '. ' + "Material"} data={element?.material_name} />
                                <DivLayout heading={"Category"} data={element?.category_name} />
                                <DivLayout heading={"Cost Value"} data={element?.cost} />
                                <DivLayout heading={"Quantity"} data={element?.quantity} />
                                <DivLayout heading={"Unit Price"} data={element?.unit_price} />
                            </>
                            )
                        })}
                    </div>
                </div>
            </div>
            {![1].includes(quotation?.quotation?.[0]?.status_id) &&
                quotation?.quotation_logs?.map((elem, ind) => {
                    return (
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">{localization.remark}s for {elem?.remarks_by}</div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <DivLayout heading={"Remarks"} data={elem?.remarks} />
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </Layout>
    );
};

export default ViewQuotation;
